// 时间单位为秒。旧节点缺少新增字段时，默认不启用定时转接。
export function normalizeNodeTransfer(node = {}) {
  const transferAfterEnabled = !!node.can_delay_hmc;
  return {
    hmc_after_play: !!node.hmc_after_play && !transferAfterEnabled,
    can_delay_hmc: transferAfterEnabled,
    hmc_delay: node.hmc_delay == null ? 1 : node.hmc_delay,
  };
}

export function validateTransferAfterSeconds(rule, value, callback, enabled) {
  if (enabled && (!Number.isSafeInteger(value) || value < 1)) {
    callback(new Error('请输入大于 0 的整数秒数'));
    return;
  }
  callback();
}
